import { useAtom } from '@reatom/npm-react'

import { Network, selectedNetworkAtom } from '@root/entities/network'
import { useTranslation } from '@root/shared/localization'

import type { ClassNameProps } from '@root/shared/react'

type HolderTableBalCellProps = {} & ClassNameProps

export const HolderTableBalanceHeader = (props: HolderTableBalCellProps) => {
  const { t } = useTranslation()
  const [network] = useAtom(selectedNetworkAtom)

  return (
    <span className={props.className}>
      {t('table.network_balance', {
        network: Network.toDisplayString(network),
      })}
    </span>
  )
}
